
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PlatformLogo } from './PlatformLogo';
import { useIsMobile } from '@/hooks/use-mobile';

interface PlatformHeaderProps {
  name: string;
  shortName: string;
  logo: string;
  connected?: boolean;
  isSupported?: boolean;
  loading?: boolean;
}

export const PlatformHeader = ({ 
  name, 
  shortName, 
  logo, 
  connected = false,
  isSupported = true,
  loading = false
}: PlatformHeaderProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 md:gap-3 max-w-[75%]">
        <PlatformLogo name={name} logo={logo} loading={loading} />
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold truncate">{name}</h3>
          <p className="text-xs md:text-sm text-muted-foreground truncate">{shortName}</p>
        </div>
      </div>
      {connected && (
        <Badge variant="default" className="bg-primary/20 text-primary hover:bg-primary/30 ml-2 whitespace-nowrap">
          {isMobile ? 'Connected' : 'Connected'}
        </Badge>
      )}
      {!isSupported && !connected && (
        <Badge variant="outline" className="bg-muted text-muted-foreground border-muted-foreground/20 ml-2 whitespace-nowrap">
          {isMobile ? 'Soon' : 'Coming Soon'}
        </Badge>
      )}
    </div>
  );
};
